/* eslint-disable no-unused-vars */
export class Audio {
  constructor () {
    this.audio = null // audio元素类型
    this.timeVal = null
    this.millisecond = 1000 // 毫秒
    this.timeUnit = this.millisecond
    this.preCurrentTime = 0
  }

  create (filePath, finished, volume) {
    return new Promise(async (resolve, reject) => {
      let preFile = { preFilePath: '' }
      if (this.audio) {
        preFile = await this.stop()
      } else {
        this.audio = document.createElement('audio')
      }
      this.audio.src = filePath
      console.log('dynamic audio mixed audio src=====', filePath)
      this.audio.crossOrigin = 'anonymous'
      this.play(filePath)
      this.setVolume(100)
      this.audio.ondurationchange = () => {
        // this.cycle(filePath, cycle)
        resolve({ preFilePath: preFile.preFilePath, msg: '创建成功' })
      }
      this.audio.onended = () => {
        if (this.timeVal) {
          clearInterval(this.timeVal)
        }
        finished({ totalTime: this.duration(), currentTime: this.duration(), filePath })
        // setTimeout(() => delete this.audio, 0)
      }
      this.audio.onerror = reject
    })
  }

  async play (filePath) {
    if (filePath) {
      await this.isThis(filePath)
    }
    this.audio.play()
    return { filePath }
  }

  async pause () {
    if (this.audio) {
      this.audio.pause()
    }
    return { preFilePath: this.audio.src }
  }

  async stop () {
    let { preFilePath } = await this.pause()
    if (this.timeVal) {
      clearInterval(this.timeVal)
    }
    // delete this.audio
    return { preFilePath }
  }

  delete () {
    delete this.audio
  }

  async isThis (filePath) {
    if (filePath !== this.audio.src) throw '和当前播放的不是同一个文件'
  }

  async setVolume (volume) {
    let equivalentValue = 100
    let _volume = volume / equivalentValue
    this.audio.volume = _volume
    if (this.audio.volume === _volume) {
      console.log('audio mixed volume success', this.audio.volume)
      return '设置音量成功'
    } else {
      console.log('audio mixed volume fail', this.audio.volume)
      throw '设置音量失败'
    }
  }

  updateProcess (filePath, period, process) {
    if (this.timeVal) {
      clearInterval(this.timeVal)
    }
    this.timeVal = setInterval(() => {
      if (this.preCurrentTime !== this.currentTime() && this.audio.src === filePath) {
        this.preCurrentTime = this.currentTime()
        process({ totalTime: this.duration(), currentTime: this.preCurrentTime, filePath })
      }
    }, period)
  }

  currentTime () {
    if (!this.audio) return 0
    return Math.floor(this.audio.currentTime * this.timeUnit)
  }

  duration () {
    if (!this.audio) return 0
    return Math.floor(this.audio.duration * this.timeUnit)
  }

  /**
   * 循环播放控制
   * @param filePath
   * @param cycle
   */
  cycle (filePath, cycle) {
    let threshold = 1
    let shrink = 0.5
    if (!cycle) {
      this.pause()
    } else {
      this.audio.loop = true
      setTimeout(() => {
        if (this.audio) {
          this.audio.loop = false
        }
      }, Math.floor(this.duration() * (cycle - shrink)))
    }
  }
}
